import type { MouseEvent } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTermsHref } from 'shared/hooks/useTermsHref.js';
import { RoutePaths } from 'shared/routes.js';

export const useTopBarAvatarEffects = () => {
  const [menuAnchorElement, setMenuAnchor] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const termsHref = useTermsHref();

  const openMenu = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const navigateToProfile = () => {
    closeMenu();
    void navigate(RoutePaths.PROFILE_SETTINGS);
  };

  const navigateToTermsAndConditions = () => {
    closeMenu();
    window.open(termsHref, '_blank', 'noopener,noreferrer');
  };

  return {
    closeMenu,
    openMenu,
    menuAnchorElement,
    isMenuOpen: Boolean(menuAnchorElement),
    navigateToProfile,
    navigateToTermsAndConditions,
  };
};
